<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    <p [innerHtml]="message"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="close(false)">Nej</button>
    <button mat-raised-button (click)="close(true)">Ja</button>
</mat-dialog-actions>
